<template>
  <svg width="83" height="93" viewBox="0 0 83 93" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_5511_121023)">
      <path
        opacity="0.8"
        d="M8.0332 20.4408C8.0332 14.0144 13.2429 8.80469 19.6694 8.80469H54.5793C61.0058 8.80469 66.2155 14.0144 66.2155 20.4408V64.802C66.2155 71.2285 61.0058 76.4381 54.5793 76.4381H19.6694C13.2429 76.4381 8.0332 71.2285 8.0332 64.802V20.4408Z"
        fill="url(#paint0_linear_5511_121023)"
      />
      <rect x="13.8516" y="14.625" width="46.5458" height="45.8162" rx="9.45438" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M37.5253 31.5078C37.9576 31.5078 38.3081 31.8615 38.3081 32.2977V37.8269H43.7874C44.2197 37.8269 44.5701 38.1805 44.5701 38.6168C44.5701 39.053 44.2197 39.4066 43.7874 39.4066H38.3081V44.9358C38.3081 45.3721 37.9576 45.7257 37.5253 45.7257C37.093 45.7257 36.7425 45.3721 36.7425 44.9358V39.4066H31.2632C30.8309 39.4066 30.4805 39.053 30.4805 38.6168C30.4805 38.1805 30.8309 37.8269 31.2632 37.8269H36.7425V32.2977C36.7425 31.8615 37.093 31.5078 37.5253 31.5078Z"
        fill="#3F83F8"
        stroke="#3F83F8"
        stroke-width="0.21875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_5511_121023"
        x="0.0332031"
        y="0.804688"
        width="82.1816"
        height="91.6328"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dx="4" dy="4" />
        <feGaussianBlur stdDeviation="6" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.393125 0 0 0 0 0.438812 0 0 0 0 0.85 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5511_121023" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5511_121023" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_5511_121023" x1="8.0332" y1="-3.92204" x2="80.571" y2="79.3726" gradientUnits="userSpaceOnUse">
        <stop offset="0.0893332" stop-color="#66D4F7" />
        <stop offset="0.592795" stop-color="#4D92FF" />
        <stop offset="0.890565" stop-color="#BB65FF" />
      </linearGradient>
    </defs>
  </svg>
</template>
